import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const editChallengeScoreWeightingRequest = createAction(
    'editChallengeScoreWeightingRequest',
);
export const editChallengeScoreWeightingSuccess = createAction<Challenge>(
    'editChallengeScoreWeightingSuccess',
);
export const editChallengeScoreWeightingFailure = createAction(
    'editChallengeScoreWeightingFailure',
);

export const editChallengeScoreWeighting = (
    challengeID: number,
    postbody: EditChallengeScoreWeightingRequest,
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(editChallengeScoreWeightingRequest());
    try {
        const { data } = await api.patch<EditChallengeScoreWeightingRequest, Challenge>(
            `admin/challenges/${challengeID}/weighting`,
            postbody,
        );

        dispatch(editChallengeScoreWeightingSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, editChallengeScoreWeightingFailure, e);
    }
};

export interface EditChallengeScoreWeightingRequest {
    deploymentScale: number;
    fitWithChallenge: number;
    credibilityCompany: number;
    credibilityTechnology: number;
    fullOrPartialSolution: number;
}
